// extracted by mini-css-extract-plugin
export var headerCell = "_6i-1";
export var loadingSpinnerContainer = "_6i-4";
export var rowWrapper = "_6i-3";
export var standaloneTable = "_6i-5";
export var table = "_6i-0";
export var white = "_6i-2";